import {httpClient} from '../../common/api/HttpClient';

export const trainingApi = {
    uploadTraining: (data) => httpClient.post(`filehandling/importCsvAnnotated`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }),
    downloadTraining: (data, grouping) => httpClient.post(`filehandling/excel/exportExcel?grouping=${grouping}`, data, {responseType: 'blob'}),
    findByDate: (date) => httpClient.get(`trainings/current?date=${date}`),
    findBetween: (startDate, endDate) => httpClient.get(`trainings/between?startDate=${startDate}&endDate=${endDate}`),
    findAfter: (startDate) => httpClient.get(`trainings/after?date=${startDate}`),
    findAll: () => httpClient.get(`trainings/all`),
    getTrainingById: (uuid) => httpClient.get(`trainings/?uuid=${uuid}`),
    getShareTokenForTraining: (uuid) => httpClient.get(`trainings/share/?uuid=${uuid}`),
    getSharedTrainingByToken: (token) => httpClient.get(`shared/trainingByToken/?token=${token}`),
    setTrainingDetails: (details) => httpClient.put(`trainings/`, details),
    deleteTrainingById: (trainingId) => httpClient.delete(`trainings/delete?trainingId=${trainingId}`),
    deleteRunById: (runId) => httpClient.delete(`trainings/run/delete?runId=${runId}`),
    checkCanAddTraining: () => httpClient.get(`trainings/checkCanAddTraining`),
    search: (filter) => {
        if (!filter.page) {
            filter.page = 0;
        }
        if (!filter.pageSize) {
            filter.pageSize = 10;
        }
        return httpClient.post(`trainings/search`, filter);
    }
};

export default trainingApi;
